module.exports = __webpack_public_path__ + "static/media/badge-check.9be0229a.svg";